import { useState, useEffect, useContext } from 'react'

import EnvContext from '../context/EnvContext'
import { gql, useQuery } from '@apollo/client';
import { THIRTY_SECONDS } from './pollIntervals';

const HA_QUERY_v2 = gql`
query ($envName: String!) {
    ha(where: {ha_nodes: {node: {environment: {name: {_eq: $envName}}}, haNodesByHanodeid: {environment: {name: {_eq: $envName}}}}}) {
        name
        id
        ha_nodes(where: {node: {name: {_nlike: "%tih%"}}}) {
          status
          id
          node {
            name
            ip
            environment {
                name
            }
          }
          haNodesByHanodeid {
            id
            name
            environment {
                name
            }
          }
        }
    }
}
`

export const useGetHaData = (envSelected) => {

    const [lookupData, setLookupData] = useState([])
    const { data, loading } = useQuery(
        HA_QUERY_v2,
        { variables: { envName: envSelected }, pollInterval: THIRTY_SECONDS }
    )

    useEffect(() => {

        let ha_hosts = {}
        let ha_data_temp = {}

        if (data && !loading) {
            ha_data_temp = data.ha.reduce((acc, d) => {
                if (!acc[d.name]) {
                    acc[d.name] = {}
                }
                for (let ha_node of d.ha_nodes) {
                    if (ha_node.node.environment.name === envSelected) {
                        if (!ha_hosts[ha_node.node.name]) {
                            ha_hosts[ha_node.node.name] = { 'ip': ha_node.node.ip }
                        }
                        if (!acc[d.name][ha_node.node.name]) {
                            acc[d.name][ha_node.node.name] = []
                        }
                        if (ha_node.haNodesByHanodeid.environment.name === envSelected) {
                            acc[d.name][ha_node.node.name].push({ 'name': ha_node.haNodesByHanodeid.name, 'status': ha_node.status })
                        }
                    }
                }
                return acc
            }, {})
            setLookupData(ha_data_temp)
        }
    }, [data, loading, envSelected])

    return lookupData
}

const HA_QUERY_GROUPS = gql`
query ha_node($envName: String!, $node: String!) {
  ha_node(where: {node: {environment: {name: {_eq: $envName}}}, haNodesByHanodeid: {name: {_eq: $node}}}) {
    haNodesByHanodeid {
      name
    }
    ha {
      name
    }
  }
}
`

export const useHaProxyGroup = (node) => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})

    const { data, loading } = useQuery(
        HA_QUERY_GROUPS,
        { variables: { envName: envSelected, node: node }, pollInterval: THIRTY_SECONDS }
    )

    useEffect(() => {
        let tempResult = {}
        if (data && !loading && data.ha_node && data.ha_node.length > 0) {
            data.ha_node && data.ha_node.forEach(ha => {
                if (tempResult[ha.haNodesByHanodeid.name]) {
                    if (!tempResult[ha.haNodesByHanodeid.name].includes(ha.ha.name)) {
                        tempResult[ha.haNodesByHanodeid.name].push(ha.ha.name)
                    }
                } else {
                    tempResult[ha.haNodesByHanodeid.name] = [ha.ha.name]
                }
            });
            setLookupData(tempResult)
        }
    }, [data, loading])

    return lookupData
}
